import { useCallback, useMemo } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import listingLibObserver from 'framework-listing-lib/utils/listingLibObserver';
import useCrmObjectTypeTracking from 'framework-listing-lib/internal/hooks/useCrmObjectTypeTracking';
import useCrmObjectTypeName from 'framework-listing-lib/internal/hooks/useCrmObjectTypeName';
import useUserInfo from 'framework-listing-lib/internal/hooks/useUserInfo';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ListingLibExportButton({
  modalProps = {}
}) {
  const {
    hasScope
  } = useUserInfo();
  const {
    objectTypeNamePlural
  } = useCrmObjectTypeName();
  const {
    trackCrmTableInteraction
  } = useCrmObjectTypeTracking();
  const hasCrmExport = useMemo(() => hasScope('crm-export'), [hasScope]);
  const handleOpenModal = useCallback(() => {
    listingLibObserver.openExportModal(modalProps);
    trackCrmTableInteraction({
      action: 'open-export-modal'
    });
  }, [modalProps, trackCrmTableInteraction]);
  return /*#__PURE__*/_jsx(UITooltip, {
    disabled: hasCrmExport,
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "frameworkListingLib.tableActions.exportDisabledTooltip",
      options: {
        assetName: objectTypeNamePlural
      }
    }),
    children: /*#__PURE__*/_jsx(UIButton, {
      "data-test-id": "crm-listing-export-button",
      disabled: !hasCrmExport,
      onClick: handleOpenModal,
      size: "extra-small",
      use: "tertiary-extra-light",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "frameworkListingLib.tableActions.export",
        options: {
          assetName: objectTypeNamePlural
        }
      })
    })
  });
}